import 'hammerjs';
import { getSpanishPaginatorIntl } from './utils/spanish-paginator-intl';
import { CustomCurrencyMaskConfig } from './utils/customCurrencyMaskConfig';
var ɵ0 = getSpanishPaginatorIntl(), ɵ1 = CustomCurrencyMaskConfig;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1 };
